"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableContext = void 0;
var react_1 = require("react");
exports.TableContext = react_1.createContext({
    scrollStatus: "left",
    columnsWidths: [],
});
//# sourceMappingURL=TableContext.js.map